import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  email: "",
  token: "",
};

export const forgottenPassword = createSlice({
  name: "forgottenPassword",
  initialState,
  reducers: {
    update_forgotten_password_email: (state: 
      { 
        email: any, 
      }, action: { payload: any; }) => 
      {
        state.email = { ...state.email, ...action.payload };
      },
    update_forgotten_password_token: (state:
      {
        token: string,
      }, action: {payload: string;}) =>
      {
        state.token = action.payload;
      }
    },
});

export const { update_forgotten_password_email, update_forgotten_password_token } = forgottenPassword.actions;

export default forgottenPassword;